import hybrid from '@general/utils/appHybrid'

export default {
  namespaced: true,
  state: {
    audioListenersInstalled: false,
    audioState: 'stopped',
    audioIdPlaying: null,
    stationPlaying: null
  },
  mutations: {
    LISTENING_FOR_AUDIO_EVENTS(state) {
      state.audioListenersInstalled = true
    },

    AUDIO_STATE_CHANGED(state, { audioId, state: audioState, stationPlayingId }) {
      state.audioState = audioState
      state.audioIdPlaying = audioId
      state.stationPlaying = stationPlayingId
    }
  },
  actions: {
    listenForAudioEvents({ state, commit }) {
      if (state.audioListenersInstalled) { return }

      const fn = ({ audioId, state, stationPlayingId }) => {
        commit('AUDIO_STATE_CHANGED', { audioId, state, stationPlayingId })
      }

      hybrid.on('audioStateChanged', fn)
      hybrid.on('appLoad', fn)

      commit('LISTENING_FOR_AUDIO_EVENTS')
    }
  }
}